import { toast } from 'sonner'

import { getAttachmentLimitConfig } from '@/lib/billing/losi-pricing'
import { supabase } from '@/lib/supabase/browser-client'

const FILE_STORAGE_SAFETY_LIMIT =
  getAttachmentLimitConfig('business_ultra').maxAttachmentSizeBytes ??
  25 * 1024 * 1024 * 1024
const FILE_STORAGE_SAFETY_LIMIT_LABEL =
  getAttachmentLimitConfig('business_ultra').maxAttachmentSizeLabel

export const uploadFile = async (
  file: any,
  payload: {
    name: string
    user_id: string
    file_id: string
  },
  client = supabase
) => {
  if (file.size > FILE_STORAGE_SAFETY_LIMIT) {
    throw new Error(`File must be less than ${FILE_STORAGE_SAFETY_LIMIT_LABEL}`)
  }

  const filePath = `${payload.user_id}/${Buffer.from(payload.file_id).toString('base64')}`

  const { error } = await client.storage.from('files').upload(filePath, file, {
    upsert: true
  })

  if (error) {
    console.error(`Error uploading file with path: ${filePath}`, error)
    throw new Error('Error uploading file')
  }

  return filePath
}

export const deleteFileFromStorage = async (filePath: string) => {
  const { error } = await supabase.storage.from('files').remove([filePath])

  if (error) {
    toast.error('Failed to remove file!')
    return
  }
}

export const getFileFromStorage = async (filePath: string, client = supabase) => {
  const { data, error } = await client.storage.from('files').createSignedUrl(filePath, 60 * 60 * 24) // 24hrs

  if (error) {
    throw new Error('Error downloading file')
  }

  return data.signedUrl
}
